import { URLS } from '../constants'
import { dispatchFetchGet, dispatchFetchPost } from './ActionsUtil'
import {
  GET_ALL_PRODUCTS_BEGIN, GET_ALL_PRODUCTS_SUCCESS, GET_ALL_PRODUCTS_FAILURE, CLEAR_PRODUCTS,
  POST_CREATE_PRODUCT_BEGIN, POST_CREATE_PRODUCT_SUCCESS, POST_CREATE_PRODUCT_FAILURE
} from '../constants/ActionTypes'


const acGetProductsBegin = () => ({ type: GET_ALL_PRODUCTS_BEGIN, })
const acGetProductsSuccess = payload => ({
  type: GET_ALL_PRODUCTS_SUCCESS, payload: { response: payload }
})
const acGetProductsFailure = err => ({
  type: GET_ALL_PRODUCTS_FAILURE, payload: err
})

export const acGetProducts = () => {
  return dispatchFetchGet(
    `${URLS.PRODUCT.ROOT}`,
    acGetProductsBegin,
    acGetProductsSuccess,
    acGetProductsFailure,
  )
}

export const acClearProducts = () => ({ type: CLEAR_PRODUCTS })

const acPostCreateProductBegin = () => ({ type: POST_CREATE_PRODUCT_BEGIN, })
const acPostCreateProductSuccess = payload => ({
  type: POST_CREATE_PRODUCT_SUCCESS, payload: { response: payload }
})
const acPostCreateProductFailure = err => ({
  type: POST_CREATE_PRODUCT_FAILURE, payload: err
})

export const acPostCreateProduct = (name, valid_until, description, discount, special) => {
  return dispatchFetchPost(
    `${URLS.PRODUCT.ROOT}`,
    {
      name, valid_until, description, discount, special
    },
    acPostCreateProductBegin,
    acPostCreateProductSuccess,
    acPostCreateProductFailure,
  )
}